import { useGetSiteConfigQuery } from '@/src/services/cms'
import { isMobile } from '@/src/utils/helpers/browserHelpers'
import Script from 'next/script'
import { RefObject, useEffect, useState } from 'react'

type EvolutionFrameType = {
  url: string
  iframeRef: RefObject<HTMLIFrameElement | null>
  className?: string
}

const EvolutionFrame = ({ url, iframeRef, className }: EvolutionFrameType) => {
  const { data: site_config } = useGetSiteConfigQuery({ country: 'SWE' })
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    if (window.EvolutionGaming) {
      setIsLoaded(true)
    }
  }, [])

  useEffect(() => {
    if (window.EvolutionGaming && site_config && isLoaded && isMobile()) {
      window.EvolutionGaming?.init({
        iframeId: 'evolution-game-frame',
        topBar: 75,
        allowFullscreen: false,
      })
    }

    return () => {
      window.EvolutionGaming?.removeEventListeners()
      // Evolution library is modifying the body height, so we need to reset it
      document.body.removeAttribute('style')
      document.getElementsByTagName('html')[0].removeAttribute('style')
    }
  }, [isLoaded, site_config])

  return (
    (site_config && (
      <>
        <Script
          strategy='afterInteractive'
          onLoad={() => setIsLoaded(true)}
          src={site_config?.evoLibraryUrl}
        />
        <iframe
          id='evolution-game-frame'
          className={className}
          data-testid='game-iframe'
          allow='xr-spatial-tracking'
          ref={iframeRef}
          src={url}
          scrolling='no'
        />
      </>
    )) ||
    null
  )
}

export default EvolutionFrame
